/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import styled from 'styled-components';

export const Img = styled.img`
  width: 30px;
  margin-right: 5px;
`;
export const Span = styled.span`
  font-size: 0.75rem;
  color: gray;
`;

export const Star = styled.span`
  color: red;
`;

export const Error = styled.span`
  color: #e11d48;
  font-size: 0.875em;
`;
